import type { AdminApiOrganization } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminOrganizationResponse =
  | AdminApiOrganization
  | {
      data?: AdminApiOrganization;
    };

const normalizeOrganization = (payload: AdminOrganizationResponse): AdminApiOrganization | null => {
  if ('id' in payload) {
    return payload;
  }
  return payload.data ?? null;
};

export default function useFetchAdminOrganization(id: number | null) {
  return useQuery({
    queryKey: ['admin', 'organizations', id],
    queryFn: async () => {
      if (!id) return null;
      const response = await fetch(`/admin/api/organizations/${id}`);
      if (!response.ok) {
        throw new Error('組織詳細の取得に失敗しました');
      }
      const data: AdminOrganizationResponse = await response.json();
      return normalizeOrganization(data);
    },
    enabled: !!id,
  });
}
